export default [
  {
    path: "/programmes/:id/scenarios/compare/",
    name: "scenario-compare",
    component: () => import("@/features/scenario-compare/pages/ScenarioComparePage.vue"),
    props: (route) => ({
      id: Number(route.params.id),
      projectId: Number(route.params.id),
      programmeId: Number(route.params.id),
    }),
    meta: {
      requiresAuth: true,
      layout: "app",
      group: "Scenarios",
      title: "Scenario Compare",
      breadcrumbs: [
        { name: "Programmes", route: "project-list" },
        { name: "Scenario Select", route: "project-workspace" },
        { name: "Scenario Compare", route: "scenario-compare" },
      ],
    },
  },

  {
    path: "/programmes/:id/compare/",
    name: "programme-compare-legacy",
    redirect: (to) => ({
      name: "scenario-compare",
      params: { id: to.params.id },
      query: to.query,
      hash: to.hash,
    }),
  },
];